// Bouton flottant de recherche (mobile) : déploie / replie la barre de recherche de l'en-tête (snippets/header-search-fab.liquid).
// La barre est cachée par le CSS en dessous de 992 px ; la classe « @search-open » de l'en-tête la montre sous la ligne du haut.
(() => {
    const fab = document.querySelector('[data-search-fab]');
    if (!fab) return;
    const header = document.getElementById(fab.getAttribute('data-target'));
    const input = header && header.querySelector('input[name="q"]');
    if (!header || !input) return;
    const OPEN = '@search-open';

    // Hauteur disponible pour la liste des résultats (variable --search-avail) : de la barre de recherche au bas de l'écran VISIBLE
    // (visualViewport : le clavier mobile n'en fait pas partie). Recalculée à l'ouverture, au redimensionnement et au défilement visuel.
    const vv = window.visualViewport;
    const updateAvail = () => {
        const sb = header.querySelector('[class~="#header-searchbar"]');
        if (!header.classList.contains('@search-open') || !sb) {
            document.documentElement.style.removeProperty('--search-avail');
            return;
        }
        const bottom = vv ? vv.offsetTop + vv.height : window.innerHeight;
        const avail = bottom - sb.getBoundingClientRect().top - 8;
        document.documentElement.style.setProperty('--search-avail', Math.max(200, Math.round(avail)) + 'px');
    };
    if (vv) { vv.addEventListener('resize', updateAvail); vv.addEventListener('scroll', updateAvail); }
    window.addEventListener('resize', updateAvail);
    // Certains navigateurs mobiles (Brave/Android) ne renvoient la hauteur finale qu'après l'animation du clavier, sans autre événement :
    // on remesure à la saisie et un peu après chaque focus.
    input.addEventListener('input', () => window.setTimeout(updateAvail, 400));
    input.addEventListener('focus', () => [350, 800, 1500].forEach((ms) => window.setTimeout(updateAvail, ms)));

    // La liste des résultats doit passer PAR-DESSUS la bulle de clavardage Tidio. Son conteneur #tidio-chat porte un style EN LIGNE
    // « z-index: 999999999 !important » que aucune feuille de style ne bat : on l'abaisse sous l'en-tête (z-index 99, dont la liste fait
    // partie) tant que la recherche est ouverte, puis on remet la valeur d'origine. La bulle reste visible ailleurs.
    const CHAT_Z = '999999999';
    const chatBelow = (below) => {
        const chat = document.getElementById('tidio-chat');
        if (chat) chat.style.setProperty('z-index', below ? '50' : CHAT_Z, 'important');
    };
    // Tidio se charge après la page : s'il arrive pendant une recherche ouverte, on l'abaisse aussi
    document.addEventListener('tidioChat-ready', () => chatBelow(header.classList.contains(OPEN)));

    // Événements dataLayer (GTM → GA4) pour mesurer la nouvelle recherche et les boutons mobiles : search_open, search_close,
    // predictive_search_click, predictive_search_view_all, floating_buttons_hide, filter_open, language_toggle, drawer_icon_click.
    const track = (event, params) => {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: event }, params || {}));
        } catch (e) { /* ignoré */ }
    };
    const term = () => (input.value || '').trim().slice(0, 100);

    const set = (open, source) => {
        if (open && !header.classList.contains(OPEN)) track('search_open', { source: source || 'floating' });
        header.classList.toggle(OPEN, open);
        fab.setAttribute('aria-expanded', open ? 'true' : 'false');
        fab.setAttribute('aria-label', fab.getAttribute(open ? 'data-label-close' : 'data-label-open'));
        // focus synchrone dans le geste du doigt : sinon le clavier ne s'ouvre pas sur iOS
        if (open) input.focus();
        else input.blur();
        updateAvail();
        chatBelow(open);
        if (open) window.setTimeout(updateAvail, 350); // après l'ouverture du clavier
    };

    // Changement de langue (deux langues : lien « EN » / « FR » de l'en-tête et du tiroir) : on va à la MÊME page dans l'autre langue
    // grâce aux <link rel="alternate" hreflang> de la page (URL traduite exacte), en gardant la recherche (?q=…) et l'ancre. Pas de POST
    // /localization : il exige un jeton d'authenticité absent des aperçus de thème (401). Sans JavaScript ou sans hreflang, le lien mène
    // à l'accueil de l'autre langue (attribut href).
    // (délégation : le lien du tiroir du menu est injecté à l'ouverture, après le chargement de la page)
    document.addEventListener('click', (e) => {
        const a = e.target.closest && e.target.closest('[data-lang-switch]');
        if (!a) return;
        track('language_toggle', { from: document.documentElement.lang || '', to: a.getAttribute('data-lang-switch') });
        const alt = document.querySelector('link[rel="alternate"][hreflang="' + a.getAttribute('data-lang-switch') + '"]');
        if (!alt) return;
        try {
            e.preventDefault();
            window.location.assign(new URL(alt.href).pathname + window.location.search + window.location.hash);
        } catch (err) { window.location.assign(a.href); }
    });
    header.querySelectorAll('[data-search-close]').forEach((b) => b.addEventListener('click', () => { track('search_close', { search_term: term() }); set(false); }));
    fab.addEventListener('click', () => set(!header.classList.contains(OPEN), 'floating'));
    // la loupe de l'en-tête (visible seulement quand les boutons flottants sont masqués) ouvre / ferme la même barre
    document.querySelectorAll('[data-search-open]').forEach((b) => b.addEventListener('click', () => set(!header.classList.contains(OPEN), 'header')));

    // Clics mesurés par délégation (la liste de résultats, le tiroir du menu et le bouton de filtre sont injectés ou rendus ailleurs)
    document.addEventListener('click', (e) => {
        const t = e.target;
        if (!t || !t.closest) return;
        // résultat de la recherche prédictive
        const item = t.closest('[class~="#predictive-search-results-item"]');
        if (item && t.closest('a.stretched-link')) {
            const wrap = item.closest('[class~="#predictive-search-results-wrapper"]') || document;
            const all = Array.prototype.slice.call(wrap.querySelectorAll('[class~="#predictive-search-results-item"]'));
            const typeEl = item.closest('[class~="#predictive-search-results-type"]');
            const m = typeEl && (typeEl.className.match(/-type-(w+)/) || [])[1];
            const types = { products: 'product', collections: 'collection', queries: 'suggestion', articles: 'article', pages: 'page' };
            track('predictive_search_click', { result_type: types[m] || m || 'product', position: all.indexOf(item) + 1, search_term: term() });
            return;
        }
        if (t.closest('[class~="#predictive-search-results-all"]')) { track('predictive_search_view_all', { search_term: term() }); return; }
        if (t.closest('[class~="#collection-filter-fab"]')) { track('filter_open'); return; }
        const tool = t.closest('[data-drawer-tool]');
        if (tool) track('drawer_icon_click', { icon: tool.getAttribute('data-drawer-tool') });
    });

    // Masquer / rappeler les boutons flottants : choix du client, mémorisé (localStorage). L'état initial est posé par le script
    // synchrone du snippet ; la classe fab-anim n'arrive qu'ensuite, pour que les boutons ne « partent » pas au chargement.
    const root = document.documentElement;
    const TUCK_KEY = 'ceramed-fab-tucked';
    const tuck = document.querySelector('[data-search-fab-tuck]');
    const syncTuck = () => {
        const tucked = root.classList.contains('fab-tucked');
        if (!tuck) return;
        tuck.setAttribute('aria-expanded', tucked ? 'false' : 'true');
        tuck.setAttribute('aria-label', tuck.getAttribute(tucked ? 'data-label-show' : 'data-label-hide'));
    };
    syncTuck();
    window.setTimeout(() => root.classList.add('fab-anim'), 60);
    if (tuck) {
        tuck.addEventListener('click', () => {
            const tucked = !root.classList.contains('fab-tucked');
            if (tucked) track('floating_buttons_hide');
            if (tucked && header.classList.contains(OPEN)) set(false);
            root.classList.toggle('fab-tucked', tucked);
            try { if (tucked) localStorage.setItem(TUCK_KEY, '1'); else localStorage.removeItem(TUCK_KEY); } catch (e) { /* ignoré */ }
            syncTuck();
        });
    }
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && header.classList.contains(OPEN)) set(false);
    });
    // un toucher en dehors de l'en-tête (et de ses résultats, qui en font partie) referme la barre
    document.addEventListener('pointerdown', (e) => {
        if (!header.classList.contains(OPEN)) return;
        if (header.contains(e.target) || fab.contains(e.target)) return;
        set(false);
    });
    window.matchMedia('(min-width: 992px)').addEventListener('change', (e) => {
        if (e.matches && header.classList.contains(OPEN)) set(false);
    });

    // Un petit tremblement du bouton, UNE fois par visite (sessionStorage), 2 s après le chargement : signale la recherche repliée.
    // Pas de tremblement si l'appareil demande moins de mouvement, si le bouton est caché (bureau) ou si la barre est déjà ouverte.
    const KEY = 'ceramed-search-fab-nudged';
    let seen = false;
    try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) { /* stockage indisponible : on tremble une fois par page */ }
    if (!seen && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.setTimeout(() => {
            if (getComputedStyle(fab).display === 'none' || header.classList.contains(OPEN) || root.classList.contains('fab-tucked')) return;
            fab.classList.add('@attention');
            fab.addEventListener('animationend', () => fab.classList.remove('@attention'), { once: true });
            try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* ignoré */ }
        }, 2000);
    }
})();
